import Hero from "../../designSystem/Hero";
import SEO from "../../designSystem/SEO";
import MortgageBorrowCalculator from "../../calculators/MortgageBorrowCalculator";
import CalculatorImage from "../../../assets/images/homepage_01.png";
import PrimaryButtonSmall from "../../designSystem/buttons/PrimaryButtonSmall";

const MortgageBorrowPage = () => (
  <div>
    <SEO
      title="Mortgage Borrowing Amount Calculator"
      description="Estimate how much you may be able to borrow for a mortgage based on your income, deposit and circumstances."
      path="/calculators/mortgage-borrow"
    />
    <Hero
     wantOverlay={false}
    >
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">
            Mortgage Calculators
          </div>
          <h1 className="text-primary-1 text-center">How much can I borrow?</h1>
            <div className="content text-primary-2 text-center">
              Enter a few key details to get an estimate of how much you could
              borrow.
            </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>
    <MortgageBorrowCalculator />
  </div>
);

export default MortgageBorrowPage;
